import { Action } from '@ngrx/store';
import { Help, HelpContextualInfo } from '@model';
import { HelpState } from '@enums';

export enum HelpActionTypes {
  HelpLoad = '[Help] Load data',
  HelpLoadSuccess = '[Help] Load success',
  HelpLoadFail = '[Help] Load fail',

  HelpSetState = '[Help] Set active',
  SelectTab = '[Help] Set selected Tab',
  HelpSetStateAndContextualInfo = '[Help] Set active help state and contextual info',
  HelpClearContextualInfo = '[Help] Clear set contextual info'
}

export class HelpLoad implements Action {
  readonly type = HelpActionTypes.HelpLoad;
  constructor() {}
}
export class HelpLoadSuccess implements Action {
  readonly type = HelpActionTypes.HelpLoadSuccess;
  constructor(public payload: Help) {}
}
export class HelpLoadFail implements Action {
  readonly type = HelpActionTypes.HelpLoadFail;
  constructor(public payload: any) {}
}
export class HelpSetState implements Action {
  readonly type = HelpActionTypes.HelpSetState;
  constructor(public payload: HelpState) {}
}
export class SelectTab implements Action {
  readonly type = HelpActionTypes.SelectTab;
  constructor(public payload: string) {}
}
export class HelpSetStateAndContextualInfo implements Action {
  readonly type = HelpActionTypes.HelpSetStateAndContextualInfo;
  constructor(public payload: {state:  HelpState; contextualInfo: HelpContextualInfo}) {}
}
export class HelpClearContextualInfo implements Action {
  readonly type = HelpActionTypes.HelpClearContextualInfo;
  constructor() {}
}


export type HelpActions = HelpLoad | HelpLoadSuccess | HelpLoadFail | HelpSetState | SelectTab | HelpSetStateAndContextualInfo | HelpClearContextualInfo;
